export type SeoFaqEntry = { heading: string; text: string };
export type SeoFaqSection = { title: string; entries: SeoFaqEntry[] };

/**
 * Mirrors the section/entry format used for ItemHazardSentences on PDP
 * (see MapArbitraryNameValuesMultiple in fog.services.shop):
 * a line ending in "#" starts a new section (title = line without the "#"),
 * every other line is an "heading;text" entry belonging to the current section.
 */
export function parseSeoFaq(value?: string | null): SeoFaqSection[] {
    if (!value) {
        return [];
    }

    const lines = value
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);

    const isHeaderLine = (line: string) => line.endsWith('#');

    const sections: SeoFaqSection[] = [];
    let current: SeoFaqSection | null = null;

    for (const line of lines) {
        if (isHeaderLine(line)) {
            current = { title: line.slice(0, -1).trim(), entries: [] };
            sections.push(current);
            continue;
        }

        if (!current) {
            current = { title: '', entries: [] };
            sections.push(current);
        }

        const [heading, ...rest] = line.split(';');
        current.entries.push({ heading: heading?.trim() ?? '', text: rest.join(';').trim() });
    }

    return sections;
}
